import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogWrapperComponent } from '../dialog-wrapper/dialog-wrapper.component';
import { LoginProfileBlockComponent } from '../../login-profile-block/login-profile-block.component';

@Component({
  selector: 'ol-guest-dialog',
  templateUrl: './guest-dialog.component.html',
  styleUrl: './guest-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DialogWrapperComponent, LoginProfileBlockComponent],
})
export class GuestDialogComponent {}
